module.exports = __webpack_public_path__ + "static/media/close.b1970de4.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/close.svg
// module id = ./src/assets/icons/close.svg
// module chunks = 0